import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
});

// localStorage keeps the auth token across tabs and after the tab/browser is
// closed. Session lasts as long as the JWT (7 days). Each device is used by
// a single role at a time; users can logout to switch roles.
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("auth_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function formatError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Bir hata oluştu";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
